import { PieChart } from '@components/chart/PieChart'
import { useWindowSize } from '@hooks/useWindowSize'
import { PieChartCardProps } from './interface'

export function PieChartCard({ data, title, legendStyle }: PieChartCardProps) {
  const { isMobile, isTablet } = useWindowSize()
  return (
    <div className='w-full shadow-card bg-white dark:bg-dark-9 rounded-[8px] border border-gray-4 dark:border-purple py-[30px] px-[40px]'>
      <PieChart
        title={title}
        data={data}
        legendStyle={legendStyle || 'left'}
        style={{
          height: isMobile
            ? data.length < 4
              ? 370
              : 500
            : isTablet
            ? data.length < 4
              ? 380
              : 500
            : 300,
          width: isMobile ? 250 : isTablet ? 300 : 490,
        }}
      />
    </div>
  )
}
